import { IconComponent } from './types';

const ReverseIcon: IconComponent<{ vertical?: boolean }> = ({
  vertical,
  style,
}) => {
  const transform = vertical ? 'rotate(90deg)' : 'rotate(0deg)';

  return (
    <svg
      height="12"
      width="12"
      viewBox="0 0 492.001 492.001"
      style={{ ...style, transform }}
    >
      <path
        fill="currentColor"
        d="M487.971,235.993l-85.468-85.464c-5.22-5.228-14.396-5.228-19.616,0l-7.452,7.448c-5.4,5.408-5.4,14.548,0.004,19.956
          l48.456,48.792H67.911l48.696-49.02c5.408-5.412,5.408-14.384,0-19.796l-7.444-7.524c-5.232-5.232-14.404-5.272-19.624-0.044
          L4.035,235.813c-2.672,2.676-4.1,6.24-4.032,9.916c-0.072,3.82,1.36,7.396,4.032,10.068l85.464,85.464
          c5.228,5.232,14.396,5.228,19.62,0l7.444-7.448c5.416-5.416,5.416-13.784,0-19.192l-49.856-49.436h358.792l-50.096,49.668
          c-2.612,2.604-4.052,5.884-4.052,9.592s1.436,7.088,4.052,9.7l7.444,7.396c2.616,2.612,6.1,4.02,9.812,4.02
          c3.716,0,7.196-1.448,9.812-4.06l85.5-85.508c2.664-2.668,4.096-6.248,4.028-9.924
          C492.075,242.245,490.639,238.665,487.971,235.993z"
      />
    </svg>
  );
};

export default ReverseIcon;
